// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".gkehaUeu0pEPsEkUCCb5J{height:100%;display:flex;flex-direction:column}._2IUFHAr7AdRY0vkUt0iAIe{font-size:.85714rem;font-weight:700;width:100%;background:#fff;text-align:center;padding:.42857rem;margin:0 0 .71429rem}.c1GFdh8mcLw2xpRvYea9L{width:100%;height:100%}.DIRkMCy-GzACTzkIhVQix{display:flex;justify-content:center;align-items:center;flex-direction:column}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cheerEmotes": "gkehaUeu0pEPsEkUCCb5J",
	"cheerEmotes__title": "_2IUFHAr7AdRY0vkUt0iAIe",
	"cheerEmotes__content": "c1GFdh8mcLw2xpRvYea9L",
	"cheerEmotes__emoteWrapper": "DIRkMCy-GzACTzkIhVQix"
};
export default ___CSS_LOADER_EXPORT___;
